import {
    Box,
    Card,
    CardContent,
    Container,
    Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import { RouteComponentProps, useLocation, withRouter } from 'react-router-dom';
import { API_SLUGS, ROUTES, STRINGS } from '../../constants';
import { axiosInstance } from '../../services/axios';
import { IUserStoreState, useUserStore } from '../../store/userState';
import MfaForm from './MfaForm';
var format = require("string-template");

const SAMLHandler: React.FC<RouteComponentProps> = ({ history }) => {
    const [isMfa, setIsMfa] = useState(false);
    const search = useLocation().search;
    const [token, setToken] = useState("");
    const callbackToken = new URLSearchParams(search).get('token');
    const { setCurrentUser, isLoggedIn, currentUser } = useUserStore(state => state) as IUserStoreState
    const handleMfa = (tkn: string) => {
        if (tkn) {
            setIsMfa(true);
            setToken(tkn);
        }
    };
    useEffect(() => {
        if (isLoggedIn) {
            const redirectTo = localStorage.getItem(
                STRINGS.LOCAL_STORAGE_REDIRECT_TO
            );
            const groupId = sessionStorage.getItem("groupId")
            const projectId = sessionStorage.getItem("projectId")
            console.log({ groupId, projectId })
            if (groupId?.length) {
                localStorage.setItem("groupId", groupId)

                if (projectId?.length) {
                    localStorage.setItem("projectId", projectId)
                }
            }
            if (redirectTo && redirectTo.trim() !== "") {
                localStorage.removeItem(STRINGS.LOCAL_STORAGE_REDIRECT_TO);
                history.push(redirectTo);
            } else {
                history.push(ROUTES.DASHBOARD);
            }
        }
        if (!isLoggedIn)
            getToken();
    }, [isLoggedIn])

    const getToken = async () => {
        try {
            let userResponse = await axiosInstance.get(format(API_SLUGS.FT_AUTH_HANDLER, { token: callbackToken }))
            setCurrentUser(userResponse.data?.data);
            if (userResponse.data?.token) {
                setIsMfa(true)
                handleMfa(userResponse.data?.token);
            } else {
                setCurrentUser(userResponse.data?.data);
            }
        } catch (error: any) {
            console.log(error)
        }
    }
    return (
        <>
            {isMfa ? (<Box
                sx={{
                    backgroundColor: "background.default",
                    display: "flex",
                    flexDirection: "column",
                    minHeight: '100%',
                }}
            >
                <Container maxWidth="sm" sx={{ py: "80px" }}>
                    <Card>
                        <CardContent
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                p: 3,
                            }}
                        >
                            <Box sx={{ maxWidth: "10em", m: "auto" }}>
                                <img style={{ maxWidth: "100%" }} src="/projectMercuryPurple.svg" alt="company_logo" />
                            </Box>
                            <Box
                                sx={{
                                    alignItems: "center",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    mb: 3,
                                }}
                            >


                                <Box>
                                    <Typography color="textPrimary" gutterBottom variant="h4">
                                        {isMfa ? "Verify Passcode" : "Login"}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box
                                sx={{
                                    flexGrow: 1,
                                }}
                            >
                                <MfaForm token={token} />
                            </Box>
                        </CardContent>
                    </Card>
                </Container>
            </Box>) : (
                <Box
                    sx={{
                        backgroundColor: 'background.default',
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: '100%',
                    }}
                >

                    <Container
                        maxWidth="sm"
                        sx={{ py: '80px' }}
                    >

                        <Card>
                            <CardContent
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    p: 3
                                }}
                            >
                                <Box
                                    sx={{
                                        alignItems: 'center',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        mb: 3
                                    }}
                                >
                                    <div>logging in ....</div>
                                </Box>


                            </CardContent>
                        </Card>
                    </Container>
                </Box>)
            }
        </>
    );
};

export default withRouter(SAMLHandler);
